/* Goal-page behaviours. No storage APIs. Motion respects reduced-motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking = false;
  var observer = null;

  function moveMark() {
    var mark = document.querySelector('#ka-goal #cgMark');
    if (mark && !reduce && window.innerWidth > 899) {
      var y = window.pageYOffset || 0;
      var travel = Math.max(-28, Math.min(0, -y * 0.09));
      mark.style.transform = 'translate3d(0,calc(-50% + ' + travel + 'px),0)';
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(moveMark);
    }
  }

  function revealCards(root) {
    var cards = root.querySelectorAll ? root.querySelectorAll('.cgResult:not([data-cg-observed])') : [];
    if (!cards.length) return;

    if ('IntersectionObserver' in window && !reduce) {
      if (!observer) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -12% 0px' });
      }
      cards.forEach(function (card) {
        card.setAttribute('data-cg-observed', 'true');
        observer.observe(card);
      });
    } else {
      cards.forEach(function (card) { card.classList.add('is-in'); });
    }
  }

  function bindStudyLinks(root) {
    var links = root.querySelectorAll ? root.querySelectorAll('[data-open]:not([data-cg-bound])') : [];
    links.forEach(function (link) {
      link.setAttribute('data-cg-bound', 'true');
      link.addEventListener('click', function (event) {
        var target = document.getElementById(link.getAttribute('data-open'));
        if (!target) return;
        event.preventDefault();
        target.open = true;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function init(root) {
    revealCards(root);
    bindStudyLinks(root);
    moveMark();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
}());
